export default "__VITE_ASSET__D95d3sgD__"